import React, { Component, ErrorInfo, ReactNode } from "react";
import styles from "./ErrorBoundary.module.css";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.fallbackCard} role="alert">
          <h2 className={styles.fallbackTitle}>Algo salió mal</h2>
          <p className={styles.fallbackMessage}>
            Ocurrió un error inesperado al cargar esta página. Por favor,
            intenta recargarla.
          </p>
          <button
            className={styles.backButton}
            onClick={() => {
              this.setState({ hasError: false }, () => window.history.back());
            }}
          >
            Volver
          </button>
          <button
            className={styles.reloadButton}
            onClick={() => window.location.reload()}
          >
            Recargar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
